import { Component, OnInit } from '@angular/core';
import { GeneralService } from '../general.service';
import { DataService } from '../data.service';

declare var Hashes: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: [
    './login.component.scss'
  ]
})

export class LoginComponent implements OnInit {

  public logo = "";
  public errorText = "";
  public displayError = false;
  public Username = "";
  public Password = "";
  public loginDisabled = false;

  constructor(
    public generalSvc: GeneralService,
    public dataSvc: DataService
  ) {
    // Set default values;
    this.logo = "https://www.iwcf.org/wp-content/uploads/2018/12/iwcflogo.png";
    this.Username = "";
    this.Password = "";

    this.onLoad();
  }

  ngOnInit() {
    // 
  }

  onLoad() {
    var errorParam = this.generalSvc.getUrlParam("err");

    if (errorParam === 0) {
      this.errorText = "You entered incorrect login details.";
      this.displayError = true;
    }
    else if (errorParam == 1) {
      this.errorText = "Please login to eNetAssess.";
      this.displayError = true;
    }
    else {
      this.displayError = false;
    }
  }

  getMembership(pass, salt) {
      var SHA1 = new Hashes.SHA1().b64(pass);
      var SHA1ws = new Hashes.SHA1().b64_hmac(pass, salt);
      return SHA1ws;
  }

  checkLogin() {
    if (this.Username.indexOf("demo") > -1)
      this.Username = "demo";

    this.dataSvc.initLogin(this.Username, this.Password);
  }

  processLogin(query) {
    var scQuery = query.replace(/\+/g, "###plus###");
  }

  submitLogin() {
    this.loginDisabled = true;
    this.checkLogin();

    setTimeout(() => {
      this.loginDisabled = false;
    }, 2500);
  }
}